import React from 'react';
import classnames from 'classnames';

import AlertIndicator from 'shared/components/AlertIndicator';

import styles from './styles.module.scss';

const IconLink = ({
  img,
  children,
  onClick,
  className,
  alt,
  icon,
  alertCount = 0
}) => {
  return (
    <div className={classnames(styles.link, className)} onClick={onClick}>
      <AlertIndicator className={styles.alertIndicator}>
        {alertCount}
      </AlertIndicator>
      {icon && (
        <div className={classnames(styles.img, 'material-icons')}>{icon}</div>
      )}
      {img && <img className={styles.img} src={img} alt={alt} />}
      <a href="# " className={styles.label}>
        {children}
      </a>
    </div>
  );
};

export default IconLink;
